module.exports = __webpack_public_path__ + "static/media/reefer-active.0054330e.svg";